import React, { useState, useEffect } from "react";
import { fetchFiles } from "../Utility/PDBStorage/PDBStorageUtils";
import { retrieveMineData } from "../Utility/ConsumeToken/consumeToken";
import { getFilePDB, deleteFilesPDB, renameFilesPDB } from "../Utility/ManageFiles/fileUtils";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Output from "../components/outputStorage";
import { sortFilesByDate } from '../Utility/Storage/storageUtils';

function DownloadPDBStorage() {
    const [files, setFiles] = useState([]);
    const [nameFilter, setNameFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        async function loadFiles() {
            try {
                const apitoken = await retrieveMineData();
                const fileList = await fetchFiles(apitoken._id, "DOWNLOAD_PDB");
                console.log("Files received:", fileList);
                setFiles(fileList);
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        loadFiles();
    }, []);

    const handleNameFilterChange = (event) => {
        setNameFilter(event.target.value);
    };

    const handleDateFilterChange = (event) => {
        setDateFilter(event.target.value);
    };

    const filteredFiles = files.filter((file) => {
        const matchesName = file.filename.toLowerCase().includes(nameFilter.toLowerCase());
        const matchesDate = dateFilter ? file.date === dateFilter : true;
        return matchesName && matchesDate;
    });

    const handleDownload = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            const fileData = await getFilePDB("DOWNLOAD_PDB", fileName, apitoken);
            const blob = new Blob([fileData.output], { type: "application/octet-stream" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        }
    };

    const handleVisualize = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            const fileData = await getFilePDB("DOWNLOAD_PDB", fileName, apitoken);
            const blob = new Blob([fileData.output], { type: "chemical/x-pdb" });
            const blobUrl = window.URL.createObjectURL(blob);
            navigate("/viewerPDB", { state: { params: { pdbResults: [{ url: blobUrl }] } } });
        } catch (error) {
            console.error("Errore nella visualizzazione del file", error);
        }
    };

    const deleteReport = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            await deleteFilesPDB(apitoken._id, "DOWNLOAD_PDB", fileName);
            alert("File deleted successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const renameReport = async (fileName, newName) => {
        try {
            const apitoken = await retrieveMineData();
            await renameFilesPDB(apitoken._id, "DOWNLOAD_PDB", fileName, newName);
            alert("File renamed successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const sortedFiles = sortFilesByDate(filteredFiles, 'desc');

    return (
        <>
            <Header />
            <div className="riga headerStorage">
                <h3 className="titolo titoloManage noMarginBottom">DOWNLOADPDB STORAGE</h3>
                <span className="description text">
                    Here, you can access and review all output files generated by our DownloadPDB tool. These files are organized and cataloged for your convenience, making it easy to locate and reuse data across various tools within the platform.
                </span>
                <div className="space"></div>
                <div className="div50">
                    <label>Search by Name:</label>
                    <input
                        type="text"
                        placeholder="Search for a specific PDB ID by typing it here...."
                        value={nameFilter}
                        onChange={handleNameFilterChange}
                    />
                </div>
                <div className="div50">
                    <label>Filter by Date:</label>
                    <input
                        type="date"
                        value={dateFilter}
                        onChange={handleDateFilterChange}
                    />
                </div>
                <div className="space"></div>
                <hr />
            </div>
            <div className="riga space-bottom bodyStorage">
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <div>
                        {sortedFiles.length === 0 || filteredFiles[0] === "DOWNLOAD_PDB does not exists." ? (
                            <p>Files not found</p>
                        ) : (
                            sortedFiles.map((file, index) => (
                                <Output
                                    key={index}
                                    name={file.filename}
                                    date={file.date}
                                    download={() => handleDownload(file.filename)}
                                    textAction="View PDB"
                                    action={() => handleVisualize(file.filename)}
                                    deleteFile={() => deleteReport(file.filename)}
                                    renameFile={(newName) => renameReport(file.filename, newName)}
                                />
                            ))
                        )}
                    </div>
                )}
            </div>
        </>
    );
}

export default DownloadPDBStorage;
